import { ReactElement } from 'react';
import { Box, Table, Thead, Tr, Th, Tbody } from '@ff-it/ui';
import { useFieldArray } from 'react-final-form-arrays';
import { AddButton, FormInlineError } from 'components';
import { Commission } from './Commission';
import { useField } from '@ff-it/form';
import { fmt, parseBig } from 'utilities';
import { controlCol } from 'styles/style.css';

export function Commissions(): ReactElement {
  const {
    input: { value: rawExecution },
  } = useField<string | null | undefined>('execution.approved', { subscription: { value: true } });

  const a = rawExecution ? parseBig(rawExecution) : undefined;

  const {
    fields: { map, value, remove, push, update, length = 0 },
  } = useFieldArray('commission', { subscription: { value: true } });
  function setCurrent(index: number): void {
    value.forEach((v, i) => {
      if (v.current && i !== index) {
        update(i, { ...v, current: false });
      } else if (i === index) {
        update(i, { ...v, current: true });
      }
    });
  }
  return (
    <Box mb="3">
      <FormInlineError name="commission" />
      <Table size="sm" mb="1" fixed>
        <Thead>
          <Tr>
            <Th textAlign="center">Target</Th>
            <Th>From</Th>
            <Th textAlign="right">To</Th>
            <Th textAlign="center">Rate, %</Th>
            <Th textAlign="right">Execution</Th>
            <Th className={controlCol} />
          </Tr>
        </Thead>
        <Tbody>
          {map((_name, index) => {
            const to = index + 1 < length ? value[index + 1].target : undefined;

            let execution;
            if (a) {
              const f = parseBig(value[index].target);
              const t = to ? parseBig(to) : undefined;

              if (t) {
                if (a.gte(f) && a.lt(t)) {
                  execution = fmt(a);
                }
              } else if (a.gte(f)) {
                execution = fmt(a);
              }
            }

            return (
              <Commission
                prevTarget={index > 0 ? value[index - 1].target : undefined}
                nextTarget={to}
                current={value[index].current}
                setCurrent={setCurrent}
                key={index}
                index={index}
                remove={index !== 0 ? remove : undefined}
                execution={execution}
              />
            );
          })}
        </Tbody>
      </Table>
      <AddButton
        testId="add-inline"
        onClick={() =>
          push({
            target: '',
            rate: '',
            current: false,
          })
        }
      >
        Add
      </AddButton>
    </Box>
  );
}
